export default __webpack_public_path__ + "a54ab052a9b78ce7425f4d16d3efea3f.png";